"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcBusinessDaysLater = void 0;
const date_fns_1 = require("date-fns");
const lodash_1 = require("lodash");
const __1 = require("../..");
const isHoliday_1 = require("../../isHoliday");
/**
 * X営業日後を計算する
 * NOTE: 0営業日後は当日が、営業日の場合にしか存在しない。
 * @see https://www.notion.so/6d1543779bda4e98917161898c06e110#a849980187ce4c8e8603950733109e18
 */
const calcBusinessDaysLater = (x, availability, nationalHolidays) => {
    let date = (0, date_fns_1.startOfDay)(new Date());
    // 0営業日後の場合
    if (x === 0) {
        if (isBusinessDay(date, availability, nationalHolidays))
            return date;
        // NOTE:
        // 0営業日後が営業日でない、本来はnullを返すが正しいが
        // この関数を利用しているbusinessDaysLaterCanBeBookedFilter側で
        // 翌営業日後を返してくれた方が都合がいいので、翌営業日を返すようにしている。
        return findNextBusinessDate(date, availability, nationalHolidays);
    }
    // 1営業日後〜
    (0, lodash_1.times)(x, () => {
        date = findNextBusinessDate(date, availability, nationalHolidays);
    });
    return date;
};
exports.calcBusinessDaysLater = calcBusinessDaysLater;
/**
 * 次の営業日を返す
 * @param baseDate 基準日
 * @param availability 各曜日のavailability
 * @returns 次の営業日
 */
const findNextBusinessDate = (baseDate, availability, nationalHolidays) => {
    let nextBusinessDate = null;
    // 翌日から始める
    let date = (0, date_fns_1.addDays)(baseDate, 1);
    while ((0, lodash_1.isNull)(nextBusinessDate)) {
        if (isBusinessDay(date, availability, nationalHolidays)) {
            // 営業日の場合はループを終了
            nextBusinessDate = date;
        }
        else {
            // 営業日でない場合は1日足す
            date = (0, date_fns_1.addDays)(date, 1);
        }
    }
    return nextBusinessDate;
};
/**
 * 営業日かを判定する
 * @param date 日付
 * @param availability 各曜日のavailability
 * @returns 営業日かどうか
 */
const isBusinessDay = (date, availability, nationalHolidays) => {
    const dayName = (0, isHoliday_1.isHoliday)(date, nationalHolidays)
        ? 'hol'
        : (0, __1.formatEnDayName)(date).toLowerCase();
    return availability[dayName];
};
//# sourceMappingURL=calcBusinessDaysLater.js.map